// DOC: https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

const isAmplitudeEnabled =
  process?.env?.ENVIRONMENT === 'prod' ||
  process?.env?.FORCE_AMPLITUDE === 'true';

const sendEvent = ({ action, category, label, properties }) => {
  amplitude.track(action, {
    category,
    label,
    properties,
  });
};

const amplitudeIdentifyUser = (userId, userProperties = {}) => {
  const id = userId != null ? String(userId) : '';
  if (id.length < 5) return;

  amplitude.setUserId(id);

  const identifyEvent = new amplitude.Identify();

  Object.entries(userProperties).forEach(([key, value]) => {
    identifyEvent.set(key, value);
  });

  amplitude.identify(identifyEvent);
};

export default ({ app }, inject) => {
  if (isAmplitudeEnabled) {
    // Every click and field change was tracked automatically (~2.6M events a
    // month) and no chart uses them; page views and $sendEvent events stay.
    amplitude.init(process.env.AMPLITUDE_API_KEY, {
      autocapture: { elementInteractions: false },
    });

    amplitude.add(
      sessionReplayPlugin({
        sampleRate: Number(process.env.AMPLITUDE_SAMPLE_RATE) || 0.1,
        forceSessionTracking: true,
        shouldInlineStylesheet: false,
        privacyConfig: {
          blockSelector: [],
        },
      }),
    );

    inject('amplitude', amplitude);

    inject('sendEvent', sendEvent);

    inject('amplitudeIdentifyUser', amplitudeIdentifyUser);
  } else {
    inject('sendEvent', ({ action, category, label, properties }) => {
      console.log(
        `AMPLITUDE: Evento registrado en desarrollo: ${action}`,
        `Categoria: ${category}`,
        `Etiqueta: ${label}`,
        `Propiedades:`,
        properties,
      );
    });

    inject('amplitudeIdentifyUser', (userId, userProperties) =>
      console.log(
        'AMPLITUDE: Identificación de usuario desactivada en desarrollo.',
      ),
    );
  }
};
